import {
  mapState,
  mapGetters,
} from 'vuex';

// @vue/component
export default {
  computed: {
    ...mapState({
      authToken: 'authToken',
      mobileAppLoginUrl: state => state.config.mobileAppLoginUrl,
    }),
    ...mapGetters('oneTimePass', {
      clientName: 'oneTimePassClientName',
    }),
    iproAccessUrl() {
      return `${this.mobileAppLoginUrl}?session_token=${this.authToken}`;
    },
  },
  methods: {
    downloadIproAccess() {
      window.open(this.iproAccessUrl, '_blank');
    },
    emitShowFeedback() {
      this.$emit('show-feedback');
    },
  },
};
